// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_invoice/list_purchase_invoices.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseInvoice } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseInvoicesRequest
 */
export class ListPurchaseInvoicesRequest extends Message<ListPurchaseInvoicesRequest> {
  /**
   * ID of the supplier to filter invoices
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Search term to filter invoices by invoice number or supplier name
   *
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber = 0;

  /**
   * Number of items per page
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * ID of the stock point to filter invoices by stock point
   *
   * @generated from field: string stock_point_id = 5;
   */
  stockPointId = "";

  /**
   * Filter to include only unpaid invoices
   *
   * @generated from field: bool only_unpaid = 6;
   */
  onlyUnpaid = false;

  constructor(data?: PartialMessage<ListPurchaseInvoicesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseInvoicesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "only_unpaid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseInvoicesRequest {
    return new ListPurchaseInvoicesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseInvoicesRequest {
    return new ListPurchaseInvoicesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseInvoicesRequest {
    return new ListPurchaseInvoicesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseInvoicesRequest | PlainMessage<ListPurchaseInvoicesRequest> | undefined, b: ListPurchaseInvoicesRequest | PlainMessage<ListPurchaseInvoicesRequest> | undefined): boolean {
    return proto3.util.equals(ListPurchaseInvoicesRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseInvoicesResponse
 */
export class ListPurchaseInvoicesResponse extends Message<ListPurchaseInvoicesResponse> {
  /**
   * List of purchase invoices
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseInvoice invoices = 1;
   */
  invoices: PurchaseInvoice[] = [];

  /**
   * Total number of purchase invoices matching the criteria
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListPurchaseInvoicesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseInvoicesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invoices", kind: "message", T: PurchaseInvoice, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseInvoicesResponse {
    return new ListPurchaseInvoicesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseInvoicesResponse {
    return new ListPurchaseInvoicesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseInvoicesResponse {
    return new ListPurchaseInvoicesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseInvoicesResponse | PlainMessage<ListPurchaseInvoicesResponse> | undefined, b: ListPurchaseInvoicesResponse | PlainMessage<ListPurchaseInvoicesResponse> | undefined): boolean {
    return proto3.util.equals(ListPurchaseInvoicesResponse, a, b);
  }
}

